/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1f6b5a1e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1f6b5a1e&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__